import { Map } from 'immutable'
import {
  SET_TITLES_PROCESSING,
  SET_TITLES_DATA,
  SET_TITLES_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_TITLES_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_TITLES_DATA:
      return state
        .setIn(['data'], payload.data)
        .setIn(['processing'], false)
    case SET_TITLES_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
